import { render, staticRenderFns } from "./quessionnaireTextarea.vue?vue&type=template&id=62c9c970&scoped=true&"
import script from "./quessionnaireTextarea.vue?vue&type=script&lang=js&"
export * from "./quessionnaireTextarea.vue?vue&type=script&lang=js&"
import style0 from "./quessionnaireTextarea.vue?vue&type=style&index=0&id=62c9c970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c9c970",
  null
  
)

export default component.exports